import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { NoManagingDirector, NoManagingDirectorForm } from "./noManagingDirectorDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<NoManagingDirector>,
  data?: NoManagingDirector,
): NoManagingDirectorForm {
  return new NoManagingDirectorForm(context, data, dispatch);
}

export function handleEvent() {}

export function isValid(form: NoManagingDirectorForm): boolean {
  return form.allCompaniesHaveManagingDirector;
}

export function validate(form: NoManagingDirectorForm): boolean {
  return isValid(form);
}

export function applyForm(): NoManagingDirector {
  return { type: DecisionType.noManagingDirector };
}

export const noManagingDirectorHandler: DecisionTypeHandler<
  DecisionType.noManagingDirector,
  NoManagingDirector,
  NoManagingDirectorForm
> = {
  type: DecisionType.noManagingDirector,
  initNewForm,
  handleEvent,
  isValid,
  validate,
  applyForm,
};
